import React, { Component } from 'react';

import { Snackbar, Button } from '@material-ui/core';

class SimpleSnackbar extends Component {
    state = {
        open: false
    }

    constructor(props) {
        super(props);

        if(props.open !== undefined) {
            this.state.open = props.open;
        }
    }

    closeSnackbar = () => {
        this.setState({ open: false });
    }

    onCloseHandler = (event, reason) => {
        if(reason === 'clickaway') return;

        this.closeSnackbar();
    }
    
    render() {
        const action = <Button color="secondary" size="small" onClick={() => this.setState({ open: false })}>Dismiss</Button>;

        return (
            <Snackbar 
                {...this.props}
                open={this.state.open} 
                onClose={this.onCloseHandler} 
                action={action} />
        );
    }
}

export default SimpleSnackbar;